import { Tag } from 'antd';
import { CSSProperties, FC } from 'react';

import styles from './styles.module.scss';

type PropsType = {
  max: number;
  count: number;
  label?: string;
  className?: string;
  style?: CSSProperties;
};

export const CounterWithLimit: FC<PropsType> = ({
  max,
  count,
  className = '',
  style,
  label,
}) => {
  const limitReached = count >= max;
  const counterClassName = limitReached ? styles.textMax : styles.textRegular;
  const tagClassName = `${className} ${styles.tag}`;
  const prefix = label ? `${label}: ` : '';
  const tagColor = limitReached ? 'orange' : undefined;

  return (
    <span>
      {prefix}
      <Tag style={style} color={tagColor} className={tagClassName}>
        <span className={counterClassName}>
          {count}/{max}
        </span>
      </Tag>
    </span>
  );
};
